import { IUserContext } from "@origin-digital/event-dispatcher";

const singleLine = (value: unknown, max: number): value is string =>
  typeof value === "string" &&
  !!value.trim() &&
  value.length <= max &&
  // Reject note injection through single-line account/name fields.
  // eslint-disable-next-line no-control-regex
  !/[\x00-\x1f\x7f-\x9f\u2028\u2029]/u.test(value);

/** Browser-supplied MVP data; Account Domain independently authorizes every ID. */
export const resolveJointAccountHolderContext = (
  context: IUserContext | undefined,
  accountNumbers: string[]
): { accountIds: string[]; authorName: string } => {
  const deny = (): never => {
    throw new Error("Account context unavailable");
  };
  if (
    !context ||
    !Array.isArray(context.accounts) ||
    !singleLine(context.firstName, 100) ||
    !singleLine(context.lastName, 100) ||
    !accountNumbers.length ||
    accountNumbers.length > 50 ||
    new Set(accountNumbers).size !== accountNumbers.length
  )
    return deny();
  const authorName =
    `${context.firstName.trim()} ${context.lastName.trim()}`.replace(
      / +/g,
      " "
    );
  if (!singleLine(authorName, 200) || !/\p{L}/u.test(authorName)) return deny();
  const accountIds = accountNumbers.map((number) => {
    if (!singleLine(number, 100)) return deny();
    const matches = context.accounts.filter(
      (account) =>
        account?.backend === "KRAKEN" && account.backendAccountId === number
    );
    if (matches.length !== 1 || !singleLine(matches[0].id, 50)) return deny();
    return matches[0].id;
  });
  if (new Set(accountIds).size !== accountIds.length) return deny();
  return { accountIds, authorName };
};
